import React from "react";
import { cloneDeep } from "lodash";
import {
  Grid,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
} from "@mui/material";

import { DateTimePicker } from "@mui/x-date-pickers";

import useCommunicationLog from "./useCommunicationLog";
import { formatDateTime, getFormattedDate } from "utils/date";

import FormTextField from "components/FormFields/FormTextField";
import { COMMUNICATION_MODES } from "static/constants";
import dayjs from "dayjs";

const CommunicationLogForm = (props) => {
  const { newCommunicationLog: communicationLog, handleInputChange } =
    useCommunicationLog();

  const onInputChange = (name, value) => {
    const copy = cloneDeep(communicationLog);
    copy[name] = value;
    handleInputChange(copy);
  };

  return (
    <form style={{ margin: "4px" }}>
      <Grid container spacing={1}>
        <Grid container spacing={1} width={500}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <DateTimePicker
                value={
                  communicationLog?.communicated_date
                    ? dayjs(
                        formatDateTime(
                          communicationLog?.communicated_date,
                          "YYYY-MM-DD hh:mm:ss A"
                        )
                      )
                    : null
                }
                label="Date & Time"
                maxDate={dayjs(
                  new Date(new Date().setFullYear(new Date().getFullYear() + 2))
                )}
                minDate={dayjs(new Date(2018, 0, 1))}
                onChange={(date) => {
                  let selectedDate = date;
                  if (
                    date !== null &&
                    (date < new Date(2018, 0, 1) ||
                      date >
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() + 2)
                        ))
                  ) {
                    selectedDate = new Date();
                  }

                  onInputChange(
                    "communicated_date",
                    getFormattedDate(selectedDate, "YYYY-MM-DD hh:mm:ss A")
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="communicated_date"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} className="mt-2">
            <FormControl fullWidth variant="outlined">
              <InputLabel id="mode-label">Mode Of Communication</InputLabel>
              <Select
                labelId="mode-label"
                id="mode"
                name="mode"
                value={communicationLog?.mode}
                onChange={(event) => onInputChange("mode", event.target.value)}
                label="Mode Of Communication"
              >
                {COMMUNICATION_MODES.map((mode, index) => (
                  <MenuItem key={index} value={mode}>
                    {mode}
                  </MenuItem>
                ))}
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {communicationLog?.mode === "Other" && (
            <Grid item xs={12} className="mt-2">
              <TextField
                fullWidth
                variant="outlined"
                label="Other Communication Mode"
                name="customMode"
                value={communicationLog?.customMode}
                onChange={(event) =>
                  onInputChange("customMode", event.target.value)
                }
              />
            </Grid>
          )}

          <Grid item xs={12} style={{ textAlign: "left", margin: "10px 0" }}>
            <TextField
              fullWidth
              variant="outlined"
              name="duration"
              label="Duration (Minutes)"
              value={communicationLog?.duration}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "") // only allow numbers
                  .replace(/^[0]+/g, ""); // remove leading zeros
              }}
              onChange={(event) =>
                onInputChange("duration", event.target.value)
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormTextField
              margin="none"
              multiline
              rows={10}
              fullWidth
              placeholder="Write your communication log with the patient"
              value={communicationLog?.description}
              onChange={(event) =>
                onInputChange("description", event.target.value)
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default CommunicationLogForm;
